import type { IFunctionGetMetricWithKeys } from '~/modules/analytics/types';

import { IMetricFormatter } from '~/modules/analytics/types';
import { detectDataV2By } from '~/modules/analytics';

export const getConversionRateMetric: IFunctionGetMetricWithKeys<
  'totalSessionsThatCompletedCheckout' | 'totalSessions'
> = ({ metric }) => {
  return detectDataV2By({
    data: metric,
    extractValue: (value) => {
      return value?.totalSessionsThatCompletedCheckout && value?.totalSessions
        ? value.totalSessionsThatCompletedCheckout / value?.totalSessions
        : undefined;
    },
    formatter: IMetricFormatter.PERCENTAGE_STRING,
  });
};

export const getClickConversionRateMetric: IFunctionGetMetricWithKeys<
  'totalClicksWithRevenue' | 'totalClicked'
> = ({ metric }) => {
  return detectDataV2By({
    data: metric,
    extractValue: (value) => {
      return value?.totalClicksWithRevenue && value?.totalClicked
        ? value.totalClicksWithRevenue / value?.totalClicked
        : undefined;
    },
    formatter: IMetricFormatter.PERCENTAGE_STRING,
  });
};

export const getTotalRevenueMetric: IFunctionGetMetricWithKeys<'totalRevenue'> = ({ metric }) => {
  return detectDataV2By({
    data: metric,
    extractValue: (value) => (value?.totalRevenue ? value?.totalRevenue : undefined),
    formatter: IMetricFormatter.CURRENCY,
  });
};

export const getTotalVisitorMetric: IFunctionGetMetricWithKeys<'totalVisitors'> = ({ metric }) => {
  return detectDataV2By({
    data: metric,
    extractValue: (value) => (value?.totalVisitors ? value?.totalVisitors : undefined),
    formatter: IMetricFormatter.NORMAL,
  });
};

export const getTotalSessionMetric: IFunctionGetMetricWithKeys<'totalSessions'> = ({ metric }) => {
  return detectDataV2By({
    data: metric,
    extractValue: (value) => (value?.totalSessions ? value?.totalSessions : undefined),
    formatter: IMetricFormatter.NORMAL,
  });
};

export const getEngagedSessionMetric: IFunctionGetMetricWithKeys<'engagedSessions'> = ({
  metric,
}) => {
  return detectDataV2By({
    data: metric,
    extractValue: (value) => (value?.engagedSessions ? value?.engagedSessions : undefined),
    formatter: IMetricFormatter.NORMAL,
  });
};
export const getTotalOrderMetric: IFunctionGetMetricWithKeys<'totalOrders'> = ({ metric }) => {
  return detectDataV2By({
    data: metric,
    extractValue: (value) => (value?.totalOrders ? value?.totalOrders : undefined),
    formatter: IMetricFormatter.NORMAL,
  });
};

export const getTotalClickedMetric: IFunctionGetMetricWithKeys<'totalClicked'> = ({ metric }) => {
  return detectDataV2By({
    data: metric,
    extractValue: (value) => (value?.totalClicked ? value?.totalClicked : undefined),
    formatter: IMetricFormatter.NORMAL,
  });
};

export const getTotalPageViewedMetric: IFunctionGetMetricWithKeys<'totalPageViewed'> = ({
  metric,
}) => {
  return detectDataV2By({
    data: metric,
    extractValue: (value) => (value?.totalPageViewed ? value?.totalPageViewed : undefined),
    formatter: IMetricFormatter.NORMAL,
  });
};

export const getAverageTimeOnPageMetric: IFunctionGetMetricWithKeys<
  'totalTimeOnPage' | 'totalPageViewedHaveTimeOnPage'
> = ({ metric }) => {
  return detectDataV2By({
    data: metric,
    extractValue: (value) => {
      if (!value) return undefined;

      const averageTimeOnPage =
        value?.totalTimeOnPage && value?.totalPageViewedHaveTimeOnPage
          ? value?.totalTimeOnPage / value?.totalPageViewedHaveTimeOnPage
          : 0;
      return averageTimeOnPage ? Number(averageTimeOnPage.toFixed(2)) : undefined;
    },
    formatter: IMetricFormatter.DURATION,
  });
};

export const getAverageScrollDepthMetric: IFunctionGetMetricWithKeys<'avgScrollDepth'> = ({
  metric,
}) => {
  return detectDataV2By({
    data: metric,
    extractValue: (value) => (value?.avgScrollDepth ? value?.avgScrollDepth : undefined),
    formatter: IMetricFormatter.PERCENTAGE_STRING,
  });
};

export const getRevenuePerClickMetric: IFunctionGetMetricWithKeys<
  'totalRevenue' | 'totalClicked'
> = ({ metric }) => {
  return detectDataV2By({
    data: metric,
    extractValue: (value) => {
      return value?.totalRevenue && value?.totalClicked
        ? value.totalRevenue / value?.totalClicked
        : undefined;
    },
    formatter: IMetricFormatter.CURRENCY,
  });
};

export const getRevenuePerSessionMetric: IFunctionGetMetricWithKeys<
  'totalRevenue' | 'totalSessions'
> = ({ metric }) => {
  return detectDataV2By({
    data: metric,
    extractValue: (value) => {
      return value?.totalRevenue && value?.totalSessions
        ? value.totalRevenue / value?.totalSessions
        : undefined;
    },
    formatter: IMetricFormatter.CURRENCY,
  });
};
